(function () {
  function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  function money(cents) {
    cents = parseInt(cents, 10) || 0;
    var amt = (cents / 100).toFixed(2), noDec = Math.round(cents / 100).toString();
    var withComma = amt.replace('.', ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return withComma;
      if (k === 'amount_no_decimals_with_comma_separator') return noDec;
      return amt;
    });
  }
  var addLabel = root.getAttribute('data-add-label') || '+ Quick Add';

  /* ---------- sticky offset under theme header ---------- */
  var nav = root.querySelector('[data-hbsa-nav]');
  var header = document.querySelector('sticky-header, .header-section, #shopify-section-header, .shopify-section-header, header.header');
  function syncTop() {
    var top = 0;
    if (header) {
      var cs = getComputedStyle(header);
      var r = header.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') || r.top < 0 || header.closest('[class*="sticky"]')) {
        top = Math.max(0, Math.round(r.bottom));
      }
      if (r.bottom <= 0) top = 0;
    }
    root.style.setProperty('--hbsa-top', top + 'px');
    if (nav) root.style.setProperty('--hbsa-navh', nav.offsetHeight + 'px');
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { syncTop(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', syncTop);
  syncTop();

  /* ---------- ?cat=anchor moves that category to the top ---------- */
  var catParam = null;
  try { catParam = new URLSearchParams(location.search).get('cat'); } catch (err) {}
  if (catParam) {
    var esc = window.CSS && CSS.escape ? CSS.escape(catParam) : catParam.replace(/[^a-z0-9_-]/gi, '');
    var pick = root.querySelector('[data-hbsa-cat="' + esc + '"]');
    var firstSec = root.querySelector('[data-hbsa-cat]');
    if (pick && firstSec && pick !== firstSec) firstSec.parentNode.insertBefore(pick, firstSec);
    var pickChip = root.querySelector('[data-hbsa-chip="' + esc + '"]');
    if (pickChip) {
      var li = pickChip.parentNode;
      li.parentNode.insertBefore(li, li.parentNode.firstElementChild);
      root.querySelectorAll('.hbsa-chip').forEach(function (c) { c.classList.toggle('is-active', c === pickChip); });
    }
  }

  /* ---------- chips: smooth scroll + scrollspy ---------- */
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-hbsa-chip]'));
  var navList = root.querySelector('[data-hbsa-navlist]');
  function setActive(id) {
    chips.forEach(function (c) {
      var on = c.getAttribute('data-hbsa-chip') === id;
      c.classList.toggle('is-active', on);
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      if (on && navList && navList.scrollWidth > navList.clientWidth) {
        var left = c.parentNode.offsetLeft - 16;
        navList.scrollTo({ left: left, behavior: 'smooth' });
      }
    });
  }
  var lock = 0;
  chips.forEach(function (c) {
    c.addEventListener('click', function (e) {
      var id = c.getAttribute('data-hbsa-chip');
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      setActive(id);
      lock = Date.now();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  });
  var cats = Array.prototype.slice.call(root.querySelectorAll('[data-hbsa-cat]'));
  function spy() {
    if (Date.now() - lock < 900) return;
    var line = (parseInt(getComputedStyle(root).getPropertyValue('--hbsa-top'), 10) || 0) + (nav ? nav.offsetHeight : 0) + 40;
    var current = null;
    cats.forEach(function (s) { if (!s.hidden && s.getBoundingClientRect().top <= line) current = s; });
    if (!current) current = cats.filter(function (s) { return !s.hidden; })[0];
    if (current) {
      var id = current.getAttribute('data-hbsa-cat');
      var active = root.querySelector('.hbsa-chip.is-active');
      if (!active || active.getAttribute('data-hbsa-chip') !== id) setActive(id);
    }
  }
  window.addEventListener('scroll', function () { requestAnimationFrame(spy); }, { passive: true });

  /* ---------- protein filter ---------- */
  var totalEl = root.querySelector('[data-hbsa-total]');
  function applyFilter(p) {
    root.querySelectorAll('.hbsa-pill').forEach(function (b) {
      var on = b.getAttribute('data-hbsa-protein') === p;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var total = 0;
    cats.forEach(function (sec) {
      var n = 0;
      sec.querySelectorAll('[data-hbsa-card]').forEach(function (card) {
        var list = (card.getAttribute('data-proteins') || '').split(' ');
        var show = p === 'all' || list.indexOf(p) > -1;
        card.hidden = !show;
        if (show) n++;
      });
      total += n;
      var cnt = sec.querySelector('[data-hbsa-catcount]');
      if (cnt) cnt.textContent = n + (n === 1 ? ' product' : ' products');
      var empty = sec.querySelector('[data-hbsa-empty]');
      if (empty) empty.hidden = true;
      sec.hidden = n === 0;
      var chip = root.querySelector('[data-hbsa-chip="' + sec.getAttribute('data-hbsa-cat') + '"]');
      if (chip) chip.parentNode.hidden = n === 0;
      var promo = sec.querySelector('[data-hbsa-promo]');
      if (promo) promo.hidden = p !== 'all';
    });
    if (totalEl) totalEl.textContent = total + (total === 1 ? ' product' : ' products');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hbsa-protein]');
    if (b && root.contains(b)) applyFilter(b.getAttribute('data-hbsa-protein'));
  });

  /* ---------- card state: variant + subscribe ---------- */
  function renderPrice(card) {
    var form = card.querySelector('[data-hbsa-form]');
    var subBox = card.querySelector('[data-hbsa-sub]');
    var priceEl = card.querySelector('[data-hbsa-price]');
    var isSub = subBox && subBox.checked;
    var price = +form.dataset.price, compare = +form.dataset.compare, sub = +form.dataset.sub;
    var html;
    if (isSub && sub && sub < price) {
      html = '<span class="hbsa-price__now">' + money(sub) + '</span><s class="hbsa-price__was">' + money(price) + '</s>';
    } else {
      html = '<span class="hbsa-price__now">' + money(price) + '</span>' + (compare > price ? '<s class="hbsa-price__was">' + money(compare) + '</s>' : '');
    }
    priceEl.innerHTML = html;
    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput) planInput.value = isSub ? form.dataset.plan : '';
  }
  root.addEventListener('click', function (e) {
    var v = e.target.closest('.hbsa-variant');
    if (!v || v.disabled) return;
    var card = v.closest('[data-hbsa-card]');
    card.querySelectorAll('.hbsa-variant').forEach(function (b) {
      var on = b === v; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var form = card.querySelector('[data-hbsa-form]');
    form.dataset.variant = v.dataset.id;
    form.dataset.price = v.dataset.price;
    form.dataset.compare = v.dataset.compare;
    form.dataset.sub = v.dataset.sub;
    form.querySelector('input[name="id"]').value = v.dataset.id;
    renderPrice(card);
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-hbsa-sub]')) renderPrice(e.target.closest('[data-hbsa-card]'));
  });

  /* ---------- quick add ---------- */
  var toast = root.querySelector('[data-hbsa-toast]'), toastT;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 2600);
  }
  function openCart() {
    var R = window.Rebuy;
    if (R && R.Cart && typeof R.Cart.fetchCart === 'function') {
      try {
        R.Cart.fetchCart(function () { if (R.SmartCart && R.SmartCart.show) R.SmartCart.show(); });
        if (R.SmartCart && R.SmartCart.show) R.SmartCart.show();
        return true;
      } catch (err) {}
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hbsa-addbtn]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var form = btn.closest('[data-hbsa-form]');
    var lbl = btn.querySelector('[data-hbsa-btnlabel]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    var item = { id: +form.querySelector('input[name="id"]').value, quantity: 1 };
    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput && planInput.value) item.selling_plan = +planInput.value;
    btn.setAttribute('aria-busy', 'true'); lbl.textContent = 'Adding…';
    function reset() { btn.removeAttribute('aria-busy'); lbl.textContent = addLabel; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          reset();
          showToast((res.j && (res.j.description || res.j.message)) || 'Could not add to cart');
          return;
        }
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added'); lbl.textContent = 'Added ✓';
        setTimeout(function () { btn.classList.remove('is-added'); lbl.textContent = addLabel; }, 2200);
        var opened = false;
        try { opened = openCart(); } catch (err) {}
        if (!opened) showToast('Added to cart');
      })
      .catch(function () { reset(); showToast('Could not add to cart. Please try again.'); });
  });

  /* deep link: #anchor on load */
  if (location.hash) {
    var t = root.querySelector('[data-hbsa-cat="' + location.hash.slice(1).replace(/"/g, '') + '"]');
    if (t) setTimeout(function () { syncTop(); t.scrollIntoView({ block: 'start' }); setActive(t.getAttribute('data-hbsa-cat')); }, 300);
  }
  }
  function boot() { document.querySelectorAll('[data-hbsa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();